export const SCENARIO_STANDARD = 'standard';
export const SCENARIO_HOSPITALITY = 'hospitality';
export const SCENARIO_HOSPITALITY_WITH_EXTRAS = 'hospitality_with_extras';
export const SCENARIO_PARKING = 'parking';
export const SCENARIO_PARKING_STANDALONE = 'parking_standalone';
export const SCENARIO_STANDARD_WITH_EXTRAS = 'standard_with_extras';

export const ROUTE_DAYS = '/select-days';
export const ROUTE_TICKETS = '/select-tickets';
export const ROUTE_EXTRAS = '/select-extras';
export const ROUTE_PARKING = '/select-parking';
export const ROUTE_PARKING_STANDALONE = '/select-parking-standalone';

export const DEFAULT_SOLD_OUT_LABEL = "Sold Out";
